import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import BaseComponent from '../../../baseClasses/BaseComponent';
import PhotoPermissionsUtil from '../../../helpers/permissions/PhotoPermissionsUtil';
import StepApproval from '../StepApproval';
import CommentPopup from '../CommentPopup';
import VideoPlayer from '../../../components/VideoPlayer';
import fileTypePdfIcon from '../../../assets/images/pdf-default.png';
import fileTypeDocIcon from '../../../assets/images/doc-default.png';
import fileTypeXlsIcon from '../../../assets/images/xls-default.png';
import fileTypeMovIcon from '../../../assets/images/video-default.png';
import fileTypeOtherIcon from '../../../assets/images/other-default.png';
import AnalyticsLogger from '../../../helpers/analytics/analyticsLogger';
import dataModel from '../../../models/DataModel';
import CompletionStepUtil from '../../../helpers/CompletionStepUtil/CompletionStepUtil';
import FileUtil from '../../../helpers/FileUtil/FileUtil';
import MiscConstants from '../../../constants/MiscConstants';
import InputHelpers from '../../../helpers/InputHelpers';
import AttachmentHelper from '../../../helpers/AttachmentHelper';
import TaskCompletionStepPhotoGrid from '../PhotoUpload/TaskCompletionStepPhotoGrid';
import Iconoclast from '../../Iconoclast';
import MobileSpinner from '../../../components/MobileSpinner';

import naVideoIcon from '../../../assets/images/na-video.svg';
import naOtherIcon from '../../../assets/images/na-other.svg';
import naExcelIcon from '../../../assets/images/na-excel.svg';
import naPdfIcon from '../../../assets/images/na-pdf.svg';
import naDocIcon from '../../../assets/images/na-doc.svg';

import './MiscUpload.scss';
import Textarea from '../../Textarea';

// TODO: collapse <MiscUpload> web/mobile components
const fileTypeToNAIcons = {
  'mp4': naVideoIcon,
  'Other': naOtherIcon,
  'xls': naExcelIcon,
  'pdf': naPdfIcon,
  'doc': naDocIcon,
};

export class MiscUpload extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      stepState: '',
      fileUploadInProgress: false,
      send: false,
      showKeyboard: true,
    };
    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });

    this.fileTypeInfo = this.fileTypeInfo.bind(this);
    this.handleFileUpdate = this.handleFileUpdate.bind(this);
    this.handleOnButtonClick = this.handleOnButtonClick.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.completionStep != this.props.completionStep) {
      this.setState({ fileUploadInProgress: false });
    }
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  fileTypeInfo(hasAcceptReject) {
    const { completionStep } = this.props;
    let fileType = completionStep.requested_file_type;
    let acceptedTypes = { acceptedTypes: null, defaultImage: null, filledImage: null };
    const hasAttachments = (completionStep.attachments.length > 0);
    if (fileType) {
      if (hasAttachments) {
        //all types have this iframe except video player and default
        acceptedTypes.filledImage = AttachmentHelper.getConvertedDocumentView(completionStep.attachments[0]);
      }
      switch (fileType.toLowerCase()) {
      case 'pdf':
        acceptedTypes.acceptedTypes = '.pdf';
        acceptedTypes.defaultImage = fileTypePdfIcon;
        break;
      case 'xls':
      case 'xlt':
      case 'xlm':
      case 'xlsm':
      case 'xlsx':
      case 'xltx':
        acceptedTypes.acceptedTypes = '.xlsx, .xls, .xlsm';
        acceptedTypes.defaultImage = fileTypeXlsIcon;
        break;
      case 'doc':
      case 'docx':
      case 'dotx':
      case 'dot':
      case 'dotm':
        acceptedTypes.acceptedTypes = '.docx, .doc, .rtf, .txt';
        acceptedTypes.defaultImage = fileTypeDocIcon;
        break;
      case 'other':
      case 'Other':
        acceptedTypes.acceptedTypes = null;
        acceptedTypes.defaultImage = fileTypeOtherIcon;
        break;
      case 'mp4':
      case 'mov':
      case 'avi':
      case 'wmv':
      case 'flv':
        acceptedTypes.acceptedTypes = '.mov, .mp4, .m4v, .3gp';
        acceptedTypes.defaultImage = fileTypeMovIcon;
        const attachment = hasAttachments ? completionStep.attachments[0] : null;
        const type = attachment && attachment.upload_content_type ? attachment.upload_content_type : (attachment && attachment.upload && attachment.upload.type) ? attachment.upload.type : undefined;
        acceptedTypes.filledImage = <VideoPlayer src={hasAttachments ? completionStep.attachments[0].upload : null} width={window.innerWidth - 20} height={328} type={type} />;
        break;
      default:
        acceptedTypes.filledImage = null;
        break;
      }
    }
    return acceptedTypes;
  }

  handleAddButton() {
    this.setState({ displayUploadButtons: true });
  }

  handleKeyDown(e, type) {
    if (e.keyCode == 27) {
      this.setState({ rejectionComment: false });
    } 
    else if (e.keyCode == 13 || e.keyCode == 40) {
    
      this.setState({ rejectionComment: true });
      this.state.showKeyboard=false;
      this.handleSetInputElement(e.target,e);

    }
    // else if (e.keyCode == 13 || e.keyCode == 40) {
    //   e.preventDefault();
    //   this.handleCommentSent(type, this.state.commentText);
    // }
  }

  handleOnButtonClick(){
    this.state.send=true;
    if(this.state.commentText){
      this.handleCommentSent('reject', this.state.commentText);
    }
  }

  handleCancelComment() {
    this.setState({
      rejectionComment: false,
    });
  }

  async handleCommentSent(type, commentText) {
    this.setState({ rejectionComment: false });

    const { completionStep, task } = this.props;
    await CompletionStepUtil.handleRejected(this.props.currentUser, task, completionStep, type, this.state.commentText, this.analyticsLogger);

    this.setState({ commentText: '' });
    if (this.commentInput) {
      this.commentInput.blur();
    }
    if (this.props.mobileBridge.isMobile) {
      this.props.history.goBack();
    }
  }

  handleCommentChange(e) {
    if(e.target.value.trim()!=''){
      this.setState({ commentText: e.target.value });
    }
    else{
      this.setState({ commentText: '' });
    }
  }

  handleStepApprove() {
    const { userStepPermissions } = this.props;
    const { completionStep } = this.props;
    if (userStepPermissions.has('is_approver')) {
      this.handleApproved(completionStep);
    }
    else if (userStepPermissions.has('is_reviewer')) {
      this.handleReviewed(completionStep);
    }
  }

  handleStepReject() {
    const { userStepPermissions, completionStep, task } = this.props;
    if (userStepPermissions.has('accept/reject')) {
      if((task.has_reviewer && completionStep.reviewed_at) || !task.has_reviewer){
        this.handleRejectApproval(completionStep);
      }
      else{
        this.handleRejectReview(completionStep);
      }
    }
  }

  handleReviewed(completionStep) {
    completionStep.reviewed_at = new Date().toJSON();
    dataModel.completionCriteriaDAO.reviewCompletionCriterion(completionStep).then(response => {
      this.analyticsLogger.logReviewEvent();
      if (this.props.mobileBridge.isMobile) {
        this.props.history.goBack();
      }
    });
  }

  handleRejectReview(completionStep) {
    this.setState({ rejectionComment: true });
  }

  handleApproved(completionStep) {
    if (completionStep) {
      completionStep.task_id = this.props.task.id;
      completionStep.approved_at = new Date().toJSON();
      this.analyticsLogger.logApprovalEvent();
      dataModel.completionCriteriaDAO.approveCompletionCriterion(completionStep);

      if (this.state.uploadComment) {
        const comment = {
          caption: 'Completion Step Approved',
          body: this.state.uploadComment,
          commentable_type: 'CompletionCriterion',
          commentable_id: completionStep.id,
          user_id: this.props.currentUser.id,
        };
        dataModel.commentsDAO.createComment(comment, false, null, { recordDescriptor: { comments: {} } });
        this.setState({ uploadComment: '' });
      }
      if (this.props.mobileBridge.isMobile) {
        this.props.history.goBack();
      }
    }
  }

  handleRejectApproval(completionStep) {
    this.setState({ rejectionComment: true });
  }

  animateProgress() {
    let width = 0;
    const self = this;
    this.interval = setInterval(() => {
      if (self.progressElement && self.loadingElement) {
        let parentRect = self.loadingElement.getBoundingClientRect();

        width++;
        if (width >= parentRect.width) {
          width = 0;
        }
        self.setState({ progressWidth: width });
      }
    }, 5);
  }

  setFocus(element,e) {
    if (element && e==null && this.state.showKeyboard) {
      this.commentInput = element;
      this.commentInput.focus(); 
    }  
    else if(e && element && !this.state.showKeyboard){
      this.commentInput = element;
      this.commentInput.blur();   
    }
  }

  handleDetermineRejected(task){
    const stepsRejected = task.completion_criteria
    ? task.completion_criteria.filter(cc => {
      if (cc) {
        return (
          cc.rejected_at &&
          !cc.approved_at &&
          !cc.reviewed_at &&
          !cc.completed_at
        );
      }
      else {
        return false;
      }
    }
    )
    : [];
    return stepsRejected.length > 0;
  }

  handleSetInputElement(element,e) {
    if (element && e==null && this.state.showKeyboard) {
      this.inputElement = element;
      this.inputElement.focus(); 
    }  
    else if(e && element && !this.state.showKeyboard){
      this.inputElement = element;
      this.inputElement.blur();   
    }
  }

  getNAImageForFileType() {
    const { completionStep } = this.props;

    if (completionStep && completionStep.requested_file_type) {
      return fileTypeToNAIcons[completionStep.requested_file_type];
    }
    else return naOtherIcon;
  }

  handleNotApplicableButton() {
    const { completionStep } = this.props;
    CompletionStepUtil.handleCSNotApplicableButton(completionStep, this.analyticsLogger);
  }

  handleUndoNotApplicable() {
    const clonedStep = { ...this.props.completionStep };
    clonedStep.not_applicable = null;
    clonedStep.completed_at = null;
    CompletionStepUtil.handleCSUndoNotApplicableButton(clonedStep, this.analyticsLogger);
  }

  handleFileUpload(e) {
    e.preventDefault();
    const { completionStep, task } = this.props;
    FileUtil.handleMobileFileUpload(completionStep, task, this.handleToggleLoading, this.handleFileUpdate);
  }

  handleFileUpdate(status, updateObject) {
    if (status == 'persist') {
      this.setState({ busy: true });
    }
    else if (status == 'error') {
      this.setState({ busy: false });
      dataModel.displayInfoErrorMessage('An unexpected error was encountered processing the file.', 4000, 2, null);
    }
    else if (status == 'created') {
      this.setState({ busy: false });
      this.props.handleChildCompletionStepUpdate(updateObject);
    }
  }

  handleToggleLoading(loadingAttachment) {
    this.setState({ loadingAttachment });
  }

  createButtonList() {
    const { completionStep, userStepPermissions } = this.props;
    
    let buttons = [];

    //if na is not selected nor are there attachments uploaded, show all three options
    if (!completionStep.not_applicable &&
      PhotoPermissionsUtil.canUserEditPhoto(userStepPermissions, completionStep, this.props.task) &&
      completionStep.attachments.length < MiscConstants.MAX_NUMBER_OF_FILES) {
      buttons.push(
        <div className="button add-button" onClick={InputHelpers.debounce(this.handleFileUpload, 500)} key="add-button" />
      );
    }

    if (
      !completionStep.not_applicable && 
      !completionStep.attachments.length && 
      userStepPermissions.has('step_complete')
    ) {
      buttons.push(
        <div
          className="button na-button"
          key="no-image-button"
          onClick={this.handleNotApplicableButton}
          data-qa="not-applicable-button"
        />
      );
    }
    else if (
      completionStep.not_applicable && 
      (userStepPermissions.has('step_complete') || userStepPermissions.has('step_update')) && 
      !completionStep.reviewed_at && !completionStep.approved_at &&
      completionStep.status != 'completed'
    ) {
      buttons.push(
        <div
          className="button undo-na-button"
          key="undo-na-button"
          onClick={this.handleUndoNotApplicable}
          data-qa="not-applicable-button"
        />
      );
    }

    if (this.props.mobileBridge.isMobile) {
      buttons.push(
        <div
          key="comment-button"
          className="button comments-button"
          onClick={this.props.handleCommentsButton}
        >
          {completionStep.comments.length > 0 && <div className="indicator-dot" />}
        </div>
      );
    }

    return buttons;
  }

  createUploadContent(reviewApproveButtons) {
    const { completionStep, task } = this.props;

    let typeImage = null;

    if (completionStep.not_applicable) {
      typeImage = (
        <img
          className="mobile-misc-default-image-display"
          src={this.getNAImageForFileType()}
          alt="not applicable"
          data-qa="not-applicable-image"
        />
      );
    } 
    else if (completionStep.attachments.length == 1 && !completionStep.attachments[0].file_upload) {
      typeImage = this.fileTypeInfo(reviewApproveButtons != null).filledImage;
    }
    else if (completionStep.attachments.length > 1) {
      typeImage = (
        <TaskCompletionStepPhotoGrid
          completionStep={completionStep}
          task={task}
          attachments={completionStep.attachments}
          withAcceptReject={reviewApproveButtons ? true : false}
          userStepPermissions={this.props.userStepPermissions}
          handleFileSelected={this.props.handleFileSelected}
          uploadInProgress={this.state.loadingAttachment}
        />
      );
    }
    else {
      typeImage = (
        <img
          className="mobile-misc-default-image-display"
          alt=""
          src={this.fileTypeInfo().defaultImage}
        />
      );
    }

    return typeImage;
  }

  handleSetLIElement(element) {
    if (element) {
      this.loadingElement = element;
    }
    if (this.progressElement && this.loadingElement && !this.interval) {
      this.animateProgress();
    }
  }

  handleSetPElement(element) {
    if (element) {
      this.progressElement = element;
    }
    if (this.progressElement && this.loadingElement && !this.interval) {
      this.animateProgress();
    }
  }

  render() {
    const { 
      completionStep, task, userStepPermissions,
    } = this.props;
    const { busy } = this.state;

    let background = null;
    let commentDisplay = null;
    let reviewApproveButtons = null;
    let sendButton = (
      <div className="send-button disabled">
        <div className="send-text disabled">SEND</div>
      </div>
    );
    if (this.state.commentText && this.state.commentText!='') {
      sendButton = (
        <div className="send-button" onClick={this.handleOnButtonClick}>
          <div className="send-text">SEND</div>
        </div>
      );
    }
    if (this.state.rejectionComment) {
      if (this.props.mobileBridge.isMobile) {
        background = <div className="background-disable" onClick={this.handleCancelComment}/>;
        commentDisplay = (
          <div className="comment-input">
            <Textarea
              rows={3}
              ref={element => {this.handleSetInputElement(element,null);}}
              className="text-input"
              placeholder="You must leave a comment to reject a Completion Step."
              onChange={this.handleCommentChange}
              value={this.state.commentText}
              onKeyDown={e => this.handleKeyDown(e, 'reject')}
              dataId={completionStep.id}
              style={{ resize: 'none' }}
            />
            {sendButton}
          </div>
        );
      } else {
        const element = document.getElementById(
          'task-completion-step-comments-' + completionStep.id
        );
        const rect = element.getBoundingClientRect();
        commentDisplay = (
          <CommentPopup
            task={task}
            completionStep={completionStep}
            height={element.clientHeight}
            width={element.clientWidth}
            left={rect.left}
            top={rect.top - 20}
            type={'REJECTED'}
            commentSent={commentText =>
              this.handleCommentSent('reject', commentText)
            }
            placeholder={
              'You must leave a comment to reject a Completion Step.'
            }
            cancelComment={this.handleCancelComment}
          />
        );
      }
    }
    if (!this.state.rejectionComment && !completionStep.rejected_at &&
      userStepPermissions.has('accept/reject')) {
      reviewApproveButtons = (
        <div className="mobile-misc-approve-reject-buttons">
          <StepApproval key={(task.has_reviewer && (userStepPermissions.has('is_reviewer') || this.props.currentUser.super_admin) &&
            !completionStep.reviewed_at ? '_review' : '_approve') + completionStep.id} userStepPermissions={userStepPermissions}
            handleStepReject={this.handleStepReject}
            handleStepApprove={this.handleStepApprove}
          />
        </div>
      );
    }

    let buttons = this.createButtonList();
    let displayComponent = this.createUploadContent(reviewApproveButtons);
    const gridDisplayed = (completionStep.attachments.length > 0);

    let offlineOrBusyIndicator = null;
    if (completionStep.attachments.length == 1) {
      if (completionStep.attachments[0].file_upload && completionStep.attachments[0].file_upload.progress != null) {
        const progressStyle = this.state.progressWidth
          ? { width: this.state.progressWidth }
          : {};
        offlineOrBusyIndicator = (
          <div
            className="loading-indicator"
            id={'loading-indicator-default'}
            ref={element => {
              this.handleSetLIElement(element);
            }}
          >
            <div
              className="progress-indicator"
              id={'progress-indicator-default'}
              ref={element => {
                this.handleSetPElement(element);
              }}
              style={progressStyle}
            />
          </div>
        );
      } 
      else if (completionStep.attachments[0]._dirty) {
        offlineOrBusyIndicator = (
            <div className='offline-icon'>
              <Iconoclast type='offline-double' color='#9b9b9b' height='16px' width='21px'/>
            </div>
        );
      }
    }
    let busyIndicator = null;
    if (busy) {
      busyIndicator = (
        <MobileSpinner />
      );
    }
    return (
      <div className={'mobile-misc-upload-step' + (completionStep.instructions ? ' has-instructions' : '')} id={'misc-upload-step-' + completionStep.id}>
        { background }
        <div className={'mobile-display-and-buttons' + (gridDisplayed ? ' mobile-display-and-buttons__grid-displayed' : '')}>
          { displayComponent }
          { busyIndicator }
          { offlineOrBusyIndicator }
          <div className={'mobile-misc-file-title' + (reviewApproveButtons ? ' has-accept-reject' : '')}>
            {completionStep.attachments.length == 1 ? completionStep.attachments[0].name : ''}
          </div>
          { reviewApproveButtons }
          <div 
              className={`button-list ${
                userStepPermissions.has('accept/reject') 
                ? 'review-approve'
                : '' }
              `}
            >
              { buttons }
          </div>
          { commentDisplay }
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: dataModel,
    inProgress: state.main.inProgress,
    permissions: state.new_users ? state.new_users.permissions : null,
    currentUser: state.new_users ? state.new_users.currentUser : null,
    currentCompany: state.new_companies ? state.new_companies.currentCompany : null,
    mobileBridge: dataModel.mobileBridge,
  };
};

// For handling state change from a dispatch
export default connect(mapStateToProps, null)(withRouter(MiscUpload));



// WEBPACK FOOTER //
// ./src/components/TaskCompletionStepsMobile/MiscUpload/index.js